import { createSimpleFunctional } from '../../util/helpers'

export default createSimpleFunctional('v-breadcrumbs__divider', 'li')



// WEBPACK FOOTER //
// ../../../src/components/VBreadcrumbs/VBreadcrumbsDivider.ts